import { AxiosResponse } from "axios";

export const FETCH_ACTIVE_USER_BASE = "FETCH_ACTIVE_USER";
export interface IFetchActiveUserBaseAction {
    payload: Promise<AxiosResponse<Spintr.IActiveUser>>;
    type: typeof FETCH_ACTIVE_USER_BASE;
}

export const FETCH_ACTIVE_USER_PENDING = "FETCH_ACTIVE_USER_PENDING";
export interface IFetchActiveUserPendingAction {
    type: typeof FETCH_ACTIVE_USER_PENDING;
}

export const FETCH_ACTIVE_USER_REJECTED = "FETCH_ACTIVE_USER_REJECTED";
export interface IFetchActiveUserRejectedAction {
    type: typeof FETCH_ACTIVE_USER_REJECTED;
}

export const FETCH_ACTIVE_USER_FULFILLED = "FETCH_ACTIVE_USER_FULFILLED";
export interface IFetchActiveUserFulfilledAction 
    extends Spintr.IAsyncAction<Spintr.IActiveUser> 
{
    type: typeof FETCH_ACTIVE_USER_FULFILLED;
}

export const UPDATE_ACTIVE_USER = "UPDATE_ACTIVE_USER";
export interface IUpdateActiveUserAction {
    meta: any;
    type: typeof UPDATE_ACTIVE_USER;
}

export type FetchActiveUserAction =
      IFetchActiveUserBaseAction
    | IFetchActiveUserPendingAction
    | IFetchActiveUserRejectedAction
    | IFetchActiveUserFulfilledAction;

export type ProfileAction =
      FetchActiveUserAction
    | IUpdateActiveUserAction

export default ProfileAction;